/* ---------------------------------------------------------------------------
   <frame-picker> — "Choose Your Frame" selection.

   Written by hand rather than added to the theme's compiled bundle, whose
   webpack source project isn't available. Plain ES2019, no dependencies; it
   talks to the existing Flickity gallery through the <x-carousel> element's
   own `flickity` property.

   Desktop uses a native <select>; mobile uses a horizontal thumbnail strip.
   Both drive the same state so they stay in sync if the viewport changes.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GALLERY = '.product-gallery-carousel';

  class FramePicker extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.select = this.querySelector('[data-frame-select]');
      this.strip = this.querySelector('[data-frame-strip]');
      this.thumbs = Array.prototype.slice.call(
        this.querySelectorAll('[data-frame-option]')
      );

      var id = this.getAttribute('data-form-id');
      this.atcWrap = document.querySelector('[data-frame-atc="' + id + '"]');
      this.lockedBtn = document.querySelector('[data-frame-locked="' + id + '"]');

      if (this.select) {
        this.select.addEventListener('change', this.onSelectChange.bind(this));
      }
      this.thumbs.forEach(function (btn) {
        btn.addEventListener('click', this.onThumbClick.bind(this));
      }, this);

      this.setLocked(true);
    }

    onSelectChange(event) {
      var opt = event.target.selectedOptions[0];
      if (!opt || !opt.value) return;
      this.apply(opt.value, opt.getAttribute('data-frame'),
                 opt.getAttribute('data-image'));
    }

    onThumbClick(event) {
      var btn = event.currentTarget;
      if (btn.hasAttribute('disabled')) return;
      this.apply(btn.getAttribute('data-variant-id'),
                 btn.getAttribute('data-frame'),
                 btn.getAttribute('data-image'));
    }

    /* Commit a selection: update the form, unlock the CTA, move the gallery. */
    apply(variantId, frameNumber, imageUrl) {
      if (this.idInput) this.idInput.value = variantId;

      if (this.select && this.select.value !== variantId) {
        this.select.value = variantId;
      }
      this.thumbs.forEach(function (btn) {
        var on = btn.getAttribute('data-variant-id') === variantId;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && btn.scrollIntoView) {
          btn.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      });

      this.setLocked(false);
      this.showInGallery(imageUrl, frameNumber);

      this.dispatchEvent(new CustomEvent('frame:selected', {
        bubbles: true,
        detail: { variantId: variantId, frame: frameNumber }
      }));
    }

    setLocked(locked) {
      if (this.atcWrap) this.atcWrap.style.display = locked ? 'none' : '';
      if (this.lockedBtn) this.lockedBtn.style.display = locked ? '' : 'none';
      if (this.form) {
        this.form.setAttribute('data-frame-state', locked ? 'empty' : 'selected');
      }
    }

    /* Swap the main gallery image to the chosen artwork and hold it there.
       The 108 artworks are deliberately not carousel slides, so this replaces
       the lead image rather than paging to a slide, and stops autoplay so the
       preview can't rotate away from what was just picked. */
    showInGallery(imageUrl, frameNumber) {
      var gallery = document.querySelector(GALLERY);

      var badge = document.querySelector('[data-frame-badge]');
      if (badge && frameNumber) {
        var total = badge.getAttribute('data-total') || '';
        badge.textContent = 'Frame ' + frameNumber + (total ? ' / ' + total : '');
        badge.hidden = false;
      }

      var main = document.querySelector('[data-gallery-main]');
      if (main && imageUrl) {
        var img = main.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');   // otherwise the browser keeps the old source
          img.removeAttribute('sizes');
          img.setAttribute('src', imageUrl);
          img.setAttribute('loading', 'eager');
        }
      }

      if (!gallery) return;
      var attempts = 0;
      (function hold() {
        var flkty = gallery.flickity;
        if (!flkty) {
          if (attempts++ < 30) requestAnimationFrame(hold);
          return;
        }
        if (typeof flkty.stopPlayer === 'function') flkty.stopPlayer();
        flkty.select(0, false, false);
      })();
    }
  }

  if (!window.customElements.get('frame-picker')) {
    window.customElements.define('frame-picker', FramePicker);
  }
})();
